exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-0add155a]{font-size:5.7em;font-family:Nunito,sans-serif}#sidenavbar[data-v-0add155a]{height:100%;width:25%;min-width:200px;position:fixed;z-index:1;top:0;left:0;overflow-x:hidden;padding:0;background-color:#d0b3ff}.sidenavheader[data-v-0add155a]{padding:1em;height:23%;background-color:#3e00a1}.sidenavbody[data-v-0add155a]{padding:1em;height:80%;background-color:#d0b3ff}.report[data-v-0add155a]{height:25em}.logo-text[data-v-0add155a]{font-family:Open Sans,sans-serif}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0add155a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/NavBar.vue
// module id = 266
// module chunks = 0